import Vue from "vue";
import Vuex from "vuex";
import appStoreConfig from "./appStoreConfig";

Vue.use(Vuex);
const store = new Vuex.Store(appStoreConfig);

export default store;
